var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#919191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.667 19.167c-.337 0-.641-.203-.77-.515-.129-.311-.058-.67.18-.908l5.834-5.833c.327-.316.847-.311 1.168.01.321.321.326.841.01 1.168l-5.833 5.833c-.156.157-.368.245-.59.245zM2.397 14.068l1.334-1.334-.023-.076c-.007-.02-.642-2.045.631-3.318l4.948-4.948c1.273-1.272 3.298-.638 3.334-.626l.06.018 1.333-1.333-.886-.272c-.123-.041-3.012-.974-5.021 1.035L3.16 8.161c-2.008 2.007-1.076 4.897-1.041 5l.277.907zM5.933 17.602l1.333-1.333.076.024c.02.006 2.045.641 3.318-.632l4.947-4.948c1.271-1.272.637-3.297.626-3.333l-.019-.06 1.334-1.333.271.886c.042.123.974 3.012-1.035 5.021l-4.947 4.947c-2.008 2.007-4.898 1.076-5 1.04l-.904-.279zM12.5 8.333c-.337 0-.64-.203-.77-.514-.129-.311-.057-.67.18-.908l5.834-5.833c.327-.316.847-.312 1.168.01.322.321.326.84.01 1.168L13.09 8.089c-.156.156-.368.244-.589.244z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.a97fb28f7b78ad6d916064b367c0d993.svg";
export { ForwardRef as ReactComponent };